import React, { useState, useEffect } from 'react';
import EvaluacionPage from './pages/EvaluacionPage';

// Función para extraer token de la URL
function getTokenFromPathname() {
  const pathname = window.location.pathname;

  // Patrón: /evaluar/TOKEN o /TOKEN
  const patterns = [
    /^\/evaluar\/(.+)$/,  // /evaluar/TOKEN
    /^\/([^/]+)$/        // /TOKEN (pero no /evaluar)
  ];

  for (const pattern of patterns) {
    const match = pathname.match(pattern);
    if (match) {
      // Evitar que "evaluar" sea tratado como token
      if (match[1] !== 'evaluar') {
        return match[1];
      }
    }
  }

  return null;
}

// Función para verificar si estamos en la página de bienvenida
function isWelcomePage() {
  return window.location.pathname === '/evaluar' || window.location.pathname === '/';
}

function App() {
  const token = getTokenFromPathname();
  const isWelcome = isWelcomePage();

  const [terminalInfo, setTerminalInfo] = useState({ logo: null, descripcion: null });

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/terminales/public/info?origin=${encodeURIComponent(window.location.origin)}`)
      .then(res => res.json())
      .then(data => {
        setTerminalInfo(data);
      })
      .catch(err => {
        console.error("Error fetching terminal info:", err);
      });
  }, []);

  // Si estamos en la página de bienvenida
  if (isWelcome) {
    return <WelcomePage terminalInfo={terminalInfo} />;
  }

  // Si no hay token, mostrar página de bienvenida
  if (!token) {
    return <WelcomePage terminalInfo={terminalInfo} />;
  }

  // Si hay token, mostrar la página de evaluación
  return <EvaluacionPage token={token} terminalInfo={terminalInfo} />;
}

// Página de bienvenida
function WelcomePage({ terminalInfo }) {
  const logoSrc = terminalInfo && terminalInfo.logo 
    ? process.env.PUBLIC_URL + '/imagenes/terminales/' + terminalInfo.logo 
    : process.env.PUBLIC_URL + '/imagenes/logo_emp.png';

  const title = terminalInfo && terminalInfo.descripcion 
    ? terminalInfo.descripcion 
    : 'Sistema de Evaluaciones';

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: '#f5f6fa', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      padding: 20 
    }}>
      <div style={{ 
        maxWidth: 500, 
        background: '#fff', 
        borderRadius: 16, 
        padding: 40, 
        textAlign: 'center', 
        boxShadow: '0 4px 24px 0 rgba(30, 42, 73, 0.08)' 
      }}>
        <img
          src={logoSrc}
          alt="Logo Terminal"
          style={{ width: 200, marginBottom: 24, objectFit: 'contain' }}
        />
        <h2 style={{ color: '#1976d2', marginBottom: 16 }}>{title}</h2>
        <p style={{ color: '#666', marginBottom: 24 }}>
          Escanea el código QR o ingresa el enlace proporcionado para evaluar un local.
        </p>
        <div style={{ 
          background: '#f8f9fa', 
          borderRadius: 8, 
          padding: 16, 
          marginTop: 16 
        }}>
          <p style={{ color: '#666', fontSize: 14, margin: 0 }}>
            <strong>¡Tu opinión es importante para nosotros!</strong><br/>
            Ayúdanos a mejorar nuestros servicios.
          </p>
        </div>
      </div>
    </div>
  );
}

export default App;